<div id="globe-container" style="margin: auto; width: 100%">
  <!--<img src="../assets/globe.png" class="rotate" width="1000" height="1000" />-->
</div>
